module.exports = __webpack_public_path__ + "media/images/boxes/shop-box500-67e5e44ab3db357bb3c38d2bca171043.png";